import { useEffect, useRef } from "react";

function extractTokenFromUrl(url: string): string | null {
  try {
    const parsed = new URL(url);
    return parsed.searchParams.get("token");
  } catch (err) {
    console.warn("Invalid URL format:", url);
    return null;
  }
}

export const DeepLinkHandler = () => {
  const hasRedirected = useRef(false); // check has been redirected once

  useEffect(() => {
    const handle = (_event: any, url: string) => {
      const token = extractTokenFromUrl(url);
      if (token && !hasRedirected.current) {
        hasRedirected.current = true;
        window.electron?.ipcRenderer?.send("deep-link-hard-redirect", token);
      }
    };

    window.electron?.ipcRenderer?.on("deep-link", handle);

    const initialUrl = window.electron?.getInitialDeepLink?.();
    if (initialUrl) {
      const token = extractTokenFromUrl(initialUrl);
      if (token && !hasRedirected.current) {
        hasRedirected.current = true;
        window.electron?.ipcRenderer?.send("deep-link-hard-redirect", token);
      }
    }

    return () => {
      window.electron?.ipcRenderer?.removeListener("deep-link", handle);
    };
  }, []);

  return null;
};
